// Module
var code = `<card class="labeled-color-card flex-column mv0 pa3" ng-class="[\$ctrl.color]"> <div class="flex flex-column pa1"> <bds-typo tag="span" variant="fs-14" bold="bold" translate> {{\$ctrl.title}} </bds-typo> <bds-typo tag="span" variant="fs-14" translate> {{\$ctrl.text}} </bds-typo> </div> </card>`;
// Exports
module.exports = code;